import Icon, { IconProps } from './Icon';

export default Icon;
export type { IconProps };
